import styled from 'styled-components'
import { COLORS } from 'utils'

interface ITitle {
  margintop?: string
  marginright?: string
  marginbottom?: string
  marginleft?: string
  fontcolor?: string
  fontsize?: '16px' | '24px' | '20px'
}

export const Title = styled.h1<ITitle>`
  margin-top: ${({ margintop }) => margintop || 0};
  margin-right: ${({ marginright }) => marginright || 0};
  margin-bottom: ${({ marginbottom }) => marginbottom || 0};
  margin-left: ${({ marginleft }) => marginleft || 0};
  color: ${({ fontcolor }) => fontcolor || COLORS.black};
  font-size: ${({ fontsize }) => fontsize || '24px'};
  font-weight: 700;
  font-family: Arial, Helvetica, sans-serif;
`
